import "@ingka/svg-icon/style.scss";
import "./STHGridCard.scss";
import Constants from "../../../Constants";

const STHGridCard = ({
  title,
  icon,
  description,
  onClick,
  handIcon,
  handIconShowInWeb,
  handIconShowInKiosk,
  mode,
}) => {
  return (
    <div
      className="card-service"
      onClick={onClick}
    >
      <div className="card-service__body">
        <div className="card-service__body-center-icon-container">
          <img alt="item logo" className="center-icon" src={icon} />
        </div>
        <div className="card-service__text-wrapper">
          <h4 className="">{title}</h4>
        </div>
        <div className="card-service__description-wrapper">
          <span className="card-service__description">{description}</span>
        </div>
        {((mode === Constants.modeType.kiosk && handIconShowInKiosk) ||
          (mode !== Constants.modeType.kiosk && handIconShowInWeb)) && (
          <div className="card-service__cta">
            <span className="card-service__btn btn btn--icon-primary-inverse btn--small">
              <img alt="hand icon" className="center-icon" src={handIcon} />
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default STHGridCard;
